"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationStaffPicker = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelf"));
const StaffChooser_1 = __importDefault(require("@opsbase/web-data-choosers/StaffChooser"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
function ConversationStaffPicker(props) {
    var _a, _b;
    const { onChange } = props;
    const [staff, setStaff] = (0, react_1.useState)([]);
    const self = (0, useSelf_1.default)();
    const handleChangeStaff = (0, react_1.useCallback)(v => {
        var _a;
        setStaff(v);
        onChange((_a = v === null || v === void 0 ? void 0 : v[0]) === null || _a === void 0 ? void 0 : _a.id);
    }, [onChange]);
    return (react_1.default.createElement(Vertical_1.default, { padding: true },
        react_1.default.createElement(StaffChooser_1.default, { noBorder: true, value: staff, filters: { team: (_b = (_a = self === null || self === void 0 ? void 0 : self.accessibleTeams) === null || _a === void 0 ? void 0 : _a.ids) !== null && _b !== void 0 ? _b : [] }, onChange: handleChangeStaff, selectLabel: lib_i18n_1.default.t('select-yourself') })));
}
exports.ConversationStaffPicker = ConversationStaffPicker;
exports.default = ConversationStaffPicker;
